module.exports = __webpack_public_path__ + "static/media/evoke-slack-demo2.5b8e0cde.gif";